import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import { useGTM } from 'lib/core/hooks'
import { ProductPrice, useProductBySku } from 'lib/modules/catalog'
import { Button } from 'lib/ui'
import { ProductWrapper } from './styled'

interface Props {
  sku: string
}

export const ProductBlock = ({ sku }: Props) => {
  const { product } = useProductBySku({ sku })
  const { triggerProductClick } = useGTM()
  const history = useHistory()
  if (!product) return null

  const { image, name, price, getUrlPath } = product ?? {}
  const imageUrl = image?.default?.url
  const productUrlPath = getUrlPath()

  const callGTM = () => {
    triggerProductClick({ sku, name, listPage: 'Other' })
  }

  const handleClick = () => {
    callGTM()
    history.push(productUrlPath)
  }

  return (
    <ProductWrapper>
      <Link onClick={callGTM} to={productUrlPath} className='product-image'>
        <img src={imageUrl} alt={name} width='135' />
      </Link>
      <Link className='product-name' onClick={callGTM} to={productUrlPath}>{name}</Link>
      <div className='product-price'>
        <p>As low as</p>
        <ProductPrice renderOldPrice price={price} />
      </div>
      <Button
        onClick={handleClick}
      >
        Add to Cart
      </Button>
    </ProductWrapper>
  )
}
